import { render, staticRenderFns } from "./ShopDetail.vue?vue&type=template&id=0f062ef8&scoped=true&"
import script from "./ShopDetail.vue?vue&type=script&lang=js&"
export * from "./ShopDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShopDetail.vue?vue&type=style&index=0&id=0f062ef8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f062ef8",
  null
  
)

export default component.exports